// src/pages/componenets/PreviewMode.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BusinessPage from "../layout/BusinessPage";

const PreviewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [previewConfig, setPreviewConfig] = useState(null);

  useEffect(() => {
    if (location.state?.config) {
      setPreviewConfig(location.state.config);
    } else {
      const saved = localStorage.getItem("smartbusiness-preview");
      if (saved) setPreviewConfig(JSON.parse(saved));
    }
  }, [location.state]);

  const handleExit = () => {
    navigate("/admin");
  };

  return (
    <div>
      <BusinessPage isPreview={true} previewConfig={previewConfig} />
      <button
        onClick={handleExit}
        className="fixed bottom-6 right-6 bg-white text-gray-800 hover:bg-gray-100 shadow-2xl rounded-full w-12 h-12 flex items-center justify-center z-50"
        title="Exit Preview"
      >
        ✕
      </button>
    </div>
  );
};

export default PreviewPage;
